module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For Eva, Nathaniel, and Alexander, with love,"), _c('br'), _vm._v(" Joseph Kerman, in friendship,"), _c('br'), _vm._v(" and"), _c('br'), _vm._v(" Marianne Goldberger, with deep regard")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1544831d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ded.vue
// module id = 63
// module chunks = 0